import {Injectable} from '@angular/core';
import {IPCRender} from '../../models/ipc-render.model';

@Injectable({
    providedIn: 'root'
})
export class ElectronService {
    public static get ipcRender(): IPCRender | undefined {
        // @ts-expect-error window.ipcRender Should always be set in preload.ts in electron context
        return ElectronService.isElectronApp ? window.ipcRender : undefined;
    }

    public static isElectronApp(): boolean {
        return 'ipcRender' in window;
    }

    public static isWindows(): boolean {
        return ElectronService.ipcRender?.isWindows() || false;
    }

    public static openPath(path: string): Promise<string> {
        // @ts-expect-error Method is registered in preload.ts
        return ElectronService.ipcRender?.openPath(path);
    }

    public static openExternal(url: string): Promise<void> {
        // @ts-expect-error Method is registered in preload.ts
        return ElectronService.ipcRender?.openExternal(url);
    }
}
